export default "/images/Logo-9T-Thick-White.svg?31f709747cc88337ba95653a25ba383d";